import React , { createRef } from 'react';
import { AiOutlineClose } from "react-icons/ai";

import useStyles from './styles'
import Loading from '../Loading'

function Modal({children, title, onCancel, onSubmit, cancelText, submitText, visible, autoHeight, loading}) {
  const classes = useStyles();
  const form = createRef();

  const handleSubmit = (event) => {
    event.preventDefault();
    if (loading) return false;
    let inputs = [...document.querySelectorAll("."+form.current.className + " input, " + "."+form.current.className + " textarea, " + "."+form.current.className + " select")]
    var result = {}
    inputs.map(input => {
      result[input.name] = input.value
    })
    if (onSubmit) return onSubmit(result)
  }

  const cancelEv = (e) => {
    e.preventDefault();
    onCancel(e);
  }

  if (visible) {
    return (
      <div className={classes.modalContainer}>
        <div onClick={onCancel} className={classes.filter}></div>
        <form autoComplete={"off"} onSubmit={handleSubmit} className={classes.modal} style={autoHeight ? {height: 'auto'} : {}}>
          <div className={classes.modalHeader}>
            <div className={classes.modalTitle}>
              {title && title}
            </div>
            <div onClick={onCancel} className={classes.modalClose}>
              <AiOutlineClose></AiOutlineClose>
            </div>
          </div>
          <form autoComplete={"off"} className={classes.modalBody} ref={form} >
            {children && children}
          </form>

          <div className={classes.modalBottom}>
            {cancelText !== null && cancelText !== false && (
              <button onClick={cancelEv} style={{backgroundColor: "#999"}}>{cancelText || "Cancel"}</button>
            )}
            <button type="submit" disabled={loading}>{loading ? <Loading color={"white"} size={20}/> : submitText || "Confirm"}</button>
          </div>

        </form>
      </div>
    );
  }
  
  return false
}

export default Modal;